"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import { PaymentController } from "@/service/newProdect";
import _ from "lodash";
let PaymentPayOptions = class extends Vue {
  isShowAutoRenew() {
    var _a;
    let paymentType = _.find((_a = this._options.selected.categorys) == null ? void 0 : _a.payments, { "payment": this._options.selected.paymentType });
    if (paymentType !== void 0) {
      if (paymentType.useCoin) {
        if (this._options.selected.paymentShowAutoRenew) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      if (this._options.selected.paymentShowAutoRenew) {
        return true;
      } else {
        return false;
      }
    }
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentPayOptions.prototype, "_options", 2);
PaymentPayOptions = __decorateClass([
  Component
], PaymentPayOptions);
export {
  PaymentPayOptions as default
};
